import { openBlock, createElementBlock, renderSlot } from "@histoire/vendors/vue";
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const _sfc_main = {};
const _hoisted_1 = { class: "histoire-base-tag htw-text-center htw-text-xs htw-mx-1 htw-px-0.5 htw-h-4 htw-uppercase htw-min-w-4 htw-rounded-full htw-bg-primary-500 htw-text-white dark:htw-text-black" };
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("span", _hoisted_1, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const BaseTag = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  BaseTag as default
};
